{
  "platform": {
    "title": "platform",
    "checking": "checking",
    "failed": "failure",
    "partialShort": "partial",
    "healthy": "The platform is healthy",
    "degraded": "The platform is running with limitations",
    "partial": "Not everything is running: {{list}}",
    "noApi": "No connection to api",
    "unavailable": "Unavailable: {{list}}",
    "allUp": "All dependencies are available"
  }
}
